import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'

import * as auctionManagerStore from '@/store/auctionManager'

export {
  auctionManagerStore
}

/**
   * Search store.
   *
   * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
   */
export const createAuctionManagerMixin = (without = []) => {
  const actions = !without.includes('actions') ? mapActions(auctionManagerStore.moduleName, Object.keys(auctionManagerStore.actionTypes)) : {}
  const getters = !without.includes('getters') ? mapGetters(auctionManagerStore.moduleName, Object.keys(auctionManagerStore.getterTypes)) : {}
  const mutations = !without.includes('mutations') ? mapMutations(auctionManagerStore.moduleName, Object.keys(auctionManagerStore.mutationTypes)) : {}

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  }
}
